"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Icon = _interopRequireDefault(require("../../elements/icons/Icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Header = _styledComponents["default"].div.attrs(function () {
  return {
    className: "d-flex mb-2"
  };
}).withConfig({
  displayName: "Collapse__Header",
  componentId: "sc-19l60v1-0"
})(["&&&{border-bottom:1px solid ", ";}"], function (props) {
  return props.styles.borderColor;
});

var Title = _styledComponents["default"].div.attrs(function () {
  return {
    className: "ml-2"
  };
}).withConfig({
  displayName: "Collapse__Title",
  componentId: "sc-19l60v1-1"
})(["&&&{width:100%;color:", ";}"], function (props) {
  return props.styles.titleColor;
});

var Collapse = function Collapse(_ref) {
  var startsOpen = _ref.startsOpen,
      title = _ref.title,
      children = _ref.children,
      styles = _ref.styles;

  var _useState = (0, _react.useState)(startsOpen),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var Theme = (0, _react.useContext)(_styledComponents.ThemeContext);
  var DefaultStyle = {
    borderColor: Theme["primary-blue"],
    titleColor: Theme["primary-blue"]
  };

  var CompStyles = _objectSpread({}, DefaultStyle, {}, styles);

  return _react["default"].createElement("div", null, _react["default"].createElement(Header, {
    className: "d-flex mb-2",
    onClick: function onClick() {
      return setIsOpen(!isOpen);
    },
    styles: CompStyles
  }, isOpen ? _react["default"].createElement(_Icon["default"], {
    iconName: "fa-minus-circle"
  }) : _react["default"].createElement(_Icon["default"], {
    iconName: "fa-plus-circle"
  }), " ", _react["default"].createElement(Title, {
    styles: CompStyles
  }, title)), isOpen && children);
};

Collapse.defaultProps = {
  startsOpen: true,
  styles: {}
};
Collapse.propTypes = {
  /** title of the collapse */
  title: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].string]).isRequired,

  /** children of the collapse */
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]).isRequired,

  /** Should the collapse start open */
  startsOpen: _propTypes["default"].bool,

  /** styles override */
  styles: _propTypes["default"].object
};
var _default = Collapse;
exports["default"] = _default;